const focus = {
  inserted(el, binding) {
    if (!binding.value) return;

    el.focus();
  },
};

export { focus };
